import React, { useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = (props: any) => {
  const options = {
    // indexAxis: "y" as const,
    maintainAspectRatio: false,
    elements: {
      bar: {
        borderWidth: 0,
        // borderRadius: 6,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "right" as const,
        display: false,
      },
      title: {
        display:
          props.place === "TRANSACTION_REPORT" ||
          props.place === "REVENUE_REPORT"
            ? false
            : true,
        text: "Lead Source",
        align: "start" as const,
        color: "#142C44",
        font: {
          size: 14,
          weight: "500",
          family: "Poppins",
        },
      },
    },
    scales: {
      y: {
        grid: {
          display: false,
        },
      },
      x: {
        ticks: {
          stepSize: 1,
        },
      },
    },
  };
  const [chartData, setChartData] = React.useState([]);

  useEffect(() => {
    let dataArray = props.data;
    if (props.data) {
      let data: any = [];
      dataArray &&
        dataArray?.map((obj: any) => {
          const newObj = {
            label:
              props.place === "TRANSACTION_REPORT" && obj?.label === "Paid"
                ? "Successful"
                : obj.label,
            data: obj.data,
            backgroundColor:
              props.place === "TRANSACTION_REPORT"
                ? obj?.label === "Failed"
                  ? "#EC3939"
                  : "#11C89B"
                : props.place === "REVENUE_REPORT"
                ? obj?.label === "Overdue"
                  ? "#EC3939"
                  : "#11C89B"
                : "#11C89B",
            barThickness: 15,
          };
          data.push(newObj);
          setChartData(data);
          return null;
        });
    }
  }, [props.data]);

  const labels = props.labels;

  const data = {
    labels,
    datasets: chartData,
  };
  return (
    <>
      <Bar options={options} data={data} />
    </>
  );
};

export default BarChart;
